import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '@environments/environment';
import { StripeCardElementOptions, StripeElementsOptions } from '@stripe/stripe-js';
import { StripeCardComponent, StripeService } from 'ngx-stripe';
import { PayrixService } from '../service/payrix.service';
@Component({
  selector: 'edex-stripe-payment',
  templateUrl: './stripe-payment.component.html',
  styleUrls: ['./stripe-payment.component.scss']
})
export class StripePaymentComponent implements OnInit {

  @ViewChild(StripeCardComponent) card: StripeCardComponent;
  elementsOptions: StripeElementsOptions = { locale: 'en' };
  cardOptions: StripeCardElementOptions = {
    hidePostalCode: true,
   style: {
     base: {
       iconColor: '#000',
       color: '#000',
       fontWeight: '300',
       fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
       fontSize: '14px',
     }
   }
  };
  
  paramFields: { name?:string, email?:string, phone?:string, 
      address?:string, city?:string, state?:string, zip?:string,
  } = { name:'', email:'', phone:'', address:'', state:'', city:'', zip:''};
  loading:boolean = false;
  payrixAPi =  environment.payrix.api;
  total:string;
  skuParam:string;
  PymentForm:FormGroup
  submited:boolean=false
  today = new Date();
  id: any;
  redirectUrl:string = '';
  covertdate:string=''
  failedUrl:string = '';
  merchant_id = environment.payrix.merchant;
  InvalidRequest: boolean = false;
  split_date: any[];
  dateme: Date;
  cardValid: boolean=false;
  total1: any;
  orderNo: string;
  cardType:string = '';
  cards = ['Visa','Mastercard','Discover','AMEX','JCB',]
  cardSrc = {
    Visa: 'assets/img/cards/Visa.png',
    Mastercard : 'assets/img/cards/Mastercard.png',
    Discover : 'assets/img/cards/Discover.png',
    AMEX : 'assets/img/cards/AMEX.png',
    JCB : 'assets/img/cards/JCB.png',
  }
  constructor(private _fb:FormBuilder,
    private _activatedRoute:ActivatedRoute,
    private _payrixservice:PayrixService,
    private _router:Router,
    private _snackBar: MatSnackBar,
    private stripeService: StripeService,
    public datepipe: DatePipe) { 
    }
  ngOnInit() {
    this.total= this._activatedRoute.snapshot.queryParamMap.get('amount');
    this.skuParam = this._activatedRoute.snapshot.queryParamMap.get('sku');
    this.redirectUrl = this._activatedRoute.snapshot.queryParamMap.get('redirect_url');
    this.failedUrl = this._activatedRoute.snapshot.queryParamMap.get('failed_url');
    this.orderNo = this._activatedRoute.snapshot.queryParamMap.get('orderNo');
    
    Object.keys(this.paramFields).forEach(item => {
      this.paramFields[item] = this._activatedRoute.snapshot.queryParamMap.get(item);
    });

    if(!this.redirectUrl || !this.total || !this.skuParam) {
      this.InvalidRequest = true;
      this._snackBar.open('Invalid payment details! Please check data and try again.','',{duration:2000})
    }
    this.setPaymentForm();
    this.initPayrixForm();
  }

  initPayrixForm() {
  }

  setPaymentForm() {
    this.PymentForm=this._fb.group({
      name:[this.paramFields.name || '',Validators.required],
      email:[this.paramFields.email || '',Validators.required],
      phone:[this.paramFields.phone || '',Validators.required],
      Address:[this.paramFields.address || '',Validators.required],
      city:[this.paramFields.city || '',Validators.required],
      state:[this.paramFields.state || '',Validators.required],
      zipcode:[this.paramFields.zip || '',Validators.required],
      total:[this.total || '',Validators.required],
      skuParam:[this.skuParam || '',Validators.required],
      orderNo:[this.orderNo || '',Validators.required],
    });
  }

  get f () {
    return this.PymentForm.controls;
  }

  payrixSuccess(response) {
    this.loading = true;
    if(response && response.body && response.body.body && response.body.body.id){
      let data:any = { stripeResponse: response.body.body};
      data.txnId = response.body.body.id;
      data.paymentProcessorType = 'Stripe',
      data.merchantId = environment.stripePubkey,
      data.total = this.total;
      data.orderId = this.orderNo;
      data.sku = this.skuParam;
      data.vCardNo = new Date().getTime();
      let stallerPayload = this.generateStallerPayload(response.id, this.total)
      this.loading = true;
      this._payrixservice.stallerToken(stallerPayload).subscribe(stallerRes => {
        if(stallerRes && stallerRes.data) {
          data.stallerResponse = stallerRes.data;
          data.stallerToken = stallerRes.data.id;
          data.stallerAccount = stallerRes.data.to_account;
          this.saveTxn(data);
        } else {
          this.saveTxn(data);
        }
        this.loading = false;
      }, error => {
        this.loading = false;
        this.saveTxn(data);
      }) 
    }
  }

  saveTxn(data:any) {
    this.loading = true;
    this._payrixservice.saveTxn(data).subscribe(res => {
      this.loading = false;
      if(!res.error) {
        let prms = `acctNo=${data.stallerAccount || ''}&orderNo=${this.orderNo}&vcardNo=${data.vCardNo}&txnId=${data.txnId}`;
        let url = this.redirectUrl.indexOf('?') > -1 ? `${this.redirectUrl}&${prms}` : `${this.redirectUrl}?${prms}` ;
        window.location.replace(url);
      } else {
        this._snackBar.open(res.msg, '', { duration: 2000 });
      }
    }, error => {
      this.loading = false;
      this._snackBar.open('Oops! something went wrong while processing payment.', '', { duration: 2000 });
    })
  }
  payrixFailure(response) {
    this.loading = false;
    // console.log('error', response);
  }
  payrixValidationFail() {
    this.loading = false;
  }
  payrixonFinish(response) {
    this.loading = false;
    // console.log('onfinish', response);
  }

  placeStripeOrder(data) {
    this.loading = true;
    this._payrixservice.stripePayment(data).subscribe(res => {
      this.loading = false;
      this.payrixSuccess(res)
    }, error => {
      this.loading = false;
    })
    this.loading = false;
  }

  createToken(data:any) {
    this.loading = true;
    this.stripeService.createToken(this.card.element, { 
      name : data.name,
      address_line1: data.Address,
      address_line2: '',
      address_city: data.city,
      address_state: data.state,
      address_zip: data.zipcode,
      address_country: 'US',
    }).subscribe(
      (result) => {
        if (result.token) {
          data.token = result.token;
          this.placeStripeOrder(data);
        } else  {
          if(result.error.message) {
            this._snackBar.open(result.error.message, '', { duration: 2000 });
          }
        }
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        this._snackBar.open('Oops! something went wrong while making payment, please checkout your details and try again', '', { duration: 2000 });
      }
    )
  }

  submitStripe() {
    if(this.InvalidRequest) {
      this._snackBar.open('Invalid payment details! Please check data and try again.','',{duration:2000})
      return;
    }
    Object.keys(this.PymentForm.controls).forEach(
      item => {
        this.PymentForm.get(item).markAsDirty();
      }
    )
    this.submited=true
    if (this.PymentForm.invalid){
      return;
    }
    let data = this.PymentForm.value;
    this.createToken(data)
  }

  states = [
    { value: 'AK', name: 'Alaska'},
    { value: 'TX', name: 'Texas'},
    { value: 'AL', name: 'Alabama'},
    { value: 'AR', name: 'Arkansas'},
    { value: 'AZ', name: 'Arizona'},
    { value: 'CA', name: 'California'},
    { value: 'CO', name: 'Colorado'},
    { value: 'CT', name: 'Connecticut'},
    { value: 'DC', name: 'DistrictofColumbia'},
    { value: 'DE', name: 'Delaware'},
    { value: 'FL', name: 'Florida'},
    { value: 'GA', name: 'Georgia'},
    { value: 'HI', name: 'Hawaii'},
    { value: 'IA', name: 'Iowa'},
    { value: 'ID', name: 'Idaho'},
    { value: 'IL', name: 'Illinois'},
    { value: 'IN', name: 'Indiana'},
    { value: 'KS', name: 'Kansas'},
    { value: 'KY', name: 'Kentucky'},
    { value: 'LA', name: 'Louisiana'},
    { value: 'MA', name: 'Massachusetts'},
    { value: 'MD', name: 'Maryland'},
    { value: 'ME', name: 'Maine'},
    { value: 'MI', name: 'Michigan'},
    { value: 'MN', name: 'Minnesota'},
    { value: 'MO', name: 'Missouri'},
    { value: 'MS', name: 'Mississippi'},
    { value: 'MT', name: 'Montana'},
    { value: 'NC', name: 'NorthCarolina'},
    { value: 'ND', name: 'NorthDakota'},
    { value: 'NE', name: 'Nebraska'},
    { value: 'NH', name: 'NewHampshire'},
    { value: 'NJ', name: 'NewJersey'},
    { value: 'NM', name: 'NewMexico'},
    { value: 'NV', name: 'Nevada'},
    { value: 'NY', name: 'NewYork'},
    { value: 'OH', name: 'Ohio'},
    { value: 'OK', name: 'Oklahoma'},
    { value: 'OR', name: 'Oregon'},
    { value: 'PA', name: 'Pennsylvania'},
    { value: 'RI', name: 'RhodeIsland'},
    { value: 'SC', name: 'SouthCarolina'},
    { value: 'SD', name: 'SouthDakota'},
    { value: 'TN', name: 'Tennessee'},
    { value: 'TX', name: 'Texas'},
    { value: 'UT', name: 'Utah'},
    { value: 'VA', name: 'Virginia'},
    { value: 'VT', name: 'Vermont'},
    { value: 'WA', name: 'Washington'},
    { value: 'WI', name: 'Wisconsin'},
    { value: 'WV', name: 'WestVirginia'},
    { value: 'WY', name: 'Wyoming'}
    ];

    generateStallerPayload(txnID, amt) {
      return {
          "payment": {
              "method": 3,
              "number": "1111"
          },
          "id": txnID,
          "merchant": "t1_mer_63776f943208c754fb5fe3c",
          "type": 1,
          "expiration": "0120",
          "origin": 3,
          "total": amt,
          "swiped": 0,
          "emv": 0,
          "signature": 0
      }
    }
  
}
